module.exports = __webpack_public_path__ + "img/1.b8fdda86.png";